import { useState, useEffect } from 'react';
import axios from 'axios';
import { AlertTriangle, TrendingUp } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const usd = (n) => `USD ${Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 2 })}`;

// Muestra cuánto sube el total mensual al dar de alta una aeronave (no bloquea).
export const AircraftCostPreview = ({ open, storage }) => {
    const [p, setP] = useState(null);
    useEffect(() => {
        if (!open) return;
        axios.get(`${API}/fleet/billing-preview`).then(r => setP(r.data)).catch(() => setP(null));
    }, [open]);
    if (!p || storage) return null;
    const pilot = p.after.pilot_active;
    return (
        <div className="space-y-2" data-testid="aircraft-cost-preview">
            <div className="p-3 rounded-lg bg-primary/5 border border-primary/20 text-xs flex gap-2">
                <TrendingUp className="w-4 h-4 text-primary flex-shrink-0" />
                <span>
                    Esta aeronave suma <strong data-testid="aircraft-cost-increase">{usd(p.increase_monthly)}</strong> al mes
                    ({p.after.aircraft_count} aeronaves facturables × {usd(p.after.price_per_aircraft)}; incluye todas salvo las almacenadas).
                    {pilot
                        ? ' Durante tu periodo de prueba no se cobra.'
                        : <> Nuevo total mensual: <strong data-testid="aircraft-cost-new-total">{usd(p.after.total_monthly)}</strong>.</>}
                </span>
            </div>
            {p.out_of_range && (
                <div className="p-3 rounded-lg bg-amber-500/10 border border-amber-500/30 text-xs text-amber-500 flex gap-2" data-testid="aircraft-plan-warning">
                    <AlertTriangle className="w-4 h-4 flex-shrink-0" />
                    <span>Con esta aeronave tu flota supera el rango de tu plan. Contacta a soporte para cambiar al plan {p.suggested_plan_name}. Puedes guardarla igualmente.</span>
                </div>
            )}
        </div>
    );
};
